define('controllers/consoleApi/apiList.ctrl',['app'], function (app) {
    app.controller('apiListCtrl', ['$scope', '$state','$rootScope','$stateParams','projectManageService','biAnalyticService',
        function ($scope, $state,$rootScope,$stateParams,projectManageService,biAnalyticService) {

            var Model = $scope.Model = {};
            Model.projectKey= $stateParams.projectKey;
            $scope.clickApi = clickApi;
            $scope.searchApi =searchApi;
            $scope.chooseKit = chooseKit;
            $scope.delSearch = delSearch;
            $scope.viewAllApi = viewAllApi;
            $scope.hiddenAllApi = hiddenAllApi;
            Model.isSearch = false;
            Model.apiInfoList = [];
            Model.allApiList = [];
            Model.searchApiList = [];
            //$rootScope.checkState($state).then(function () {
            init();
            //})

            function init() {
                if(Model.projectKey == '0' ){
                    if(projectManageService.getProjectKey() !='0'){
                        $state.go($state.current.name,{projectKey:projectManageService.getProjectKey()}, {reload: true});
                    }else{
                        getAllApiList();
                    }
                }else{
                    biAnalyticService.trackPageView("APIConsole - API库页面", 'DPRM5060');
                    projectManageService.getProjectInfo({projectKey:Model.projectKey}).then(function (data) {
                        if(data && data.projectInfo){
                            Model.isHavePro = true;
                            Model.myProject = data.projectInfo;
                            projectManageService.setProjectKey(Model.myProject.projectKey);
                            getAllApiList();
                        }
                    });
                }
            }

            function viewAllApi(cateName) {
                Model.apiConsoleSettings.forEach(function (cateInfo) {
                    if(cateInfo.cateName == cateName){
                        cateInfo.showTree = true;
                    }
                })
            }
            function hiddenAllApi(cateName) {
                Model.apiConsoleSettings.forEach(function (cateInfo) {
                    if(cateInfo.cateName == cateName){
                        cateInfo.showTree = false;
                    }
                })
            }

            function getAllApiList() {
                projectManageService.getAllKitList().then(function (resp) {
                    resp.forEach(function (item) {
                        if(item.apilist && item.apilist.length>0){
                            Model.apiInfoList.push(item);
                        }
                    });
                    handleApilist();
                    Model.AllKitAPIInfoList = angular.copy(Model.apiInfoList);
                    Model.kitNameList=['全部'];
                    Model.apiInfoList.forEach(function (apiInfo) {
                        apiInfo.apilist.forEach(function (item) {
                            if(!AUI.BaseJSUtil.contains(Model.kitNameList, item.kitName)){
                                Model.kitNameList.push(item.kitName);
                            }
                            Model.allApiList.push(item);
                        });
                    })
                });
            }
            function clickApi(apiInfo) {
                $state.go('apiListDetail', {projectKey:Model.projectKey,apiID:apiInfo.apiID});
            }
            function searchApi() {
                Model.searchApiList = [];
                var apiList = [];
                Model.kitName ='全部';
                if(!Model.searchTxt || Model.searchTxt ==''){
                    Model.isSearch = false;
                    Model.apiInfoList = angular.copy(Model.AllKitAPIInfoList);
                    handleApilist();
                    return;
                }
                Model.isSearch = true;
                Model.AllKitAPIInfoList.forEach(function (api) {
                    api.apilist.forEach(function (item) {
                        if(item.langInfo.apiName.indexOf(Model.searchTxt)>-1){
                            apiList.push(item);
                        }
                    })
                });
                projectManageService.getSearchApiList(apiList).then(function (resp) {
                    Model.apiInfoList = angular.copy(resp);
                    handleApilist();
                });

                apiList.forEach(function (item) {
                    Model.searchApiList.push(item)
                });
            }

            function chooseKit() {
                if(Model.kitName == '全部'){
                    Model.apiInfoList = angular.copy(Model.AllKitAPIInfoList);
                    handleApilist();
                }else{
                    var apiList = [];
                    Model.AllKitAPIInfoList.forEach(function (api) {
                        if(api.langInfo.kitName == Model.kitName){
                            apiList.push(api);
                        }
                    });
                    Model.apiInfoList = angular.copy(apiList);
                    handleApilist();
                }
            }

            function delSearch() {
                Model.kitName ='全部';
                Model.isSearch = false;
                Model.apiInfoList = angular.copy(Model.AllKitAPIInfoList);
                handleApilist();
                Model.searchTxt ='';
            }
            //将APIList转化为大分类下的写法
            function handleApilist() {
                Model.apiConsoleSettings = angular.copy(sysParamCfg.apiConsoleSetting.categorization);
                Model.apiInfoList.forEach(function (apiInfo) {
                    apiInfo.apilist.forEach(function (api) {
                        Model.apiConsoleSettings.forEach(function (cate) {
                            if(cate.cateName == api.cateName ){
                                if(cate.apilist){
                                    cate.apilist.push(api);
                                }else{
                                    cate.apilist=[];
                                    cate.apilist.push(api);
                                }
                            }
                        })
                    })
                });
            }
        }
    ]);
});

